import React from 'react';

import { Form } from 'antd';
import cn from 'classnames';

import { Button } from '@element/index';
import { I18n } from '@utils/index';

import { FORM_KYYS } from '../useMain';

import styles from './index.module.less';

const { Item } = Form;

interface SubmitFieldProps {
  className?: string;
}

export const SubmitBtn: React.FC<SubmitFieldProps> = (props) => {
  const { className } = props;
  return (
    <Item
      className={cn(className)}
      shouldUpdate
    >
      {form => {
        const amount = form.getFieldValue(FORM_KYYS.amount); // 单个金额 或 总金额
        const num = form.getFieldValue(FORM_KYYS.num); // 发放分数
        const errors = form.getFieldsError([FORM_KYYS.amount, FORM_KYYS.num, FORM_KYYS.currency]);
        const isError = errors.some(item => !!item.errors.length);
        const assignType = form.getFieldValue(FORM_KYYS.assignType);
        return (
          <div className={styles.btnWrapper}>
            <Button
              type="primary"
              htmlType="submit"
              className={styles.submitBtn}
              disabled={!amount || !num || isError}
              borderRadius={8}
              data-buried={`send-${assignType?.toLowerCase()}-airdrop`}
            >{I18n.t('r1kBhGSP')}</Button>
          </div>
        );
      }}
    </Item>
  );
}
